// extracted by mini-css-extract-plugin
export default {"SearchSummary":"_BdWYtIB","SearchSummaryAttributes":"ELLygPlH","SearchSummaryLocation":"DnMI8C0g","ActionBarTag":"SHIMIgl_"};